import rest from '../rest/rest-service';

export const PrescriberCrosswalkService = {
    async post(body) {
        return rest.post(`${process.env.PA_ADMIN_API_URL_V2}/pa-crosswalk`, body);  
    },
    async put(body) {
        return rest.put(`${process.env.PA_ADMIN_API_URL_V2}/pa-crosswalk`, body);  
    },
    async get(id) {
        return rest.get(`${process.env.PA_ADMIN_API_URL_V2}/pa-crosswalk`, id);  
    },
    async search(body) {
        return rest.post(`${process.env.PA_ADMIN_API_URL_V2}/pa-crosswalk/search`, body);  
    },
    async delete(body) {
        return rest.del(`${process.env.PA_ADMIN_API_URL_V2}/pa-crosswalk`, body);  
    }
};



// WEBPACK FOOTER //
// ./src/services/pa/prescriber-crosswalk.service.js